import cookies from '../../libs/util.cookies'

/**
 * 市拓-我的任务（指派给我去完成的现场任务：上门勘察 / 直接打合同上门签）
 * /market/* 接口需要 appCode=YHGHT（axios 默认 WYPT 会被拒绝），走原生 fetch + Bearer token
 */
const APP_CODE = 'YHGHT'

function token() {
  return cookies.get('token') || ''
}

function api(path, data) {
  const h = { 'Content-Type': 'application/json', 'appCode': APP_CODE }
  const tk = token()
  if (tk) h['Authorization'] = 'Bearer ' + tk
  return fetch('/KYWB' + path, {
    method: 'POST',
    headers: h,
    body: JSON.stringify(data || {}),
  }).then(r => r.json()).catch(() => ({ code: 501, message: '请求失败' }))
}

/** 我的未完成待办（跨项目，含客户信息） */
export function getMyTodoList() {
  return api('/market/todo/myList', {})
}
